import Vue from 'vue'
import Vuex from 'vuex'
import { normalizarPermissoes } from './utils/permissoes'

Vue.use(Vuex)

export default new Vuex.Store({

    
    state: {
        snack: { type: 'default', msg: '', show: false },
        loading: false,
        drawer: true, // Controle do menu lateral
        user: {
            isLoggedIn: localStorage.getItem('token')?true:false,
            // Lista, sempre. Ver utils/permissoes.js - o valor guardado pode
            // ser "ROLE_A,ROLE_B" (relido do localStorage) ou um array (vindo
            // direto do login), e antes cada caso quebrava de um jeito.
            permissoes: normalizarPermissoes(localStorage.getItem('permissoes'))
        },
        username:{
            description: localStorage.getItem('username') || ''
        },
        // IBS/CBS Classes
        ibsCbsClasses: [],
        //
        // Rotina "Participante Ativo" (so visivel/utilizavel pra ROLE_MODERADOR):
        // permite escolher 1 participante pra impersonar - como se fosse o
        // unico vinculo dele - em todas as rotinas. null = ver tudo (atual).
        //
        // Persistido em localStorage pra sobreviver F5/troca de aba. Limpo
        // automaticamente no logout (lista de chaves em Header.vue).
        //
        // Formato: { id: number, nome: string } | null
        //
        participanteAtivo: (() => {
            try {
                const raw = localStorage.getItem('participanteAtivo')
                return raw ? JSON.parse(raw) : null
            } catch (e) {
                return null
            }
        })()
    },
    mutations: {
        setSnack (state, value) {
            state.snack = value
        },
        setLoading (state, value) {
            state.loading = value
        },
        SET_DRAWER (state, value) {
            state.drawer = value
        },
        setUsername (state, value) {
            state.username = value
        },
        setUserPermission (state, permissoes) {
            state.user.permissoes = normalizarPermissoes(permissoes)
        },
        LOGIN_SUCCESS(state, response) {
            state.token = response.token
        },
        // IBS/CBS Classes mutations
        SET_IBS_CBS_CLASSES(state, classes) {
            state.ibsCbsClasses = classes
        },
        ADD_IBS_CBS_CLASS(state, classe) {
            state.ibsCbsClasses.push(classe)
        },
        UPDATE_IBS_CBS_CLASS(state, classeAtualizada) {
            const index = state.ibsCbsClasses.findIndex(c => c.id === classeAtualizada.id)
            if (index !== -1) {
                Vue.set(state.ibsCbsClasses, index, classeAtualizada)
            }
        },
        REMOVE_IBS_CBS_CLASS(state, classeId) {
            const index = state.ibsCbsClasses.findIndex(c => c.id === classeId)
            if (index !== -1) {
                state.ibsCbsClasses.splice(index, 1)
            }
        },
        //
        // Atualiza o "Participante Ativo" e espelha em localStorage.
        // Passa null pra resetar (voltar a ver tudo).
        //
        setParticipanteAtivo(state, participante) {
            state.participanteAtivo = participante || null
            try {
                if (participante && participante.id != null) {
                    localStorage.setItem('participanteAtivo', JSON.stringify(participante))
                } else {
                    localStorage.removeItem('participanteAtivo')
                }
            } catch (e) {
                // localStorage indisponivel (modo privado, etc) - segue em memoria.
            }
        }
    },
    actions: {
        snackSuccess ({ commit }, msg = 'Operação realizada com sucesso!') {
            commit('setSnack', { type: 'success', msg, show: true })
        },
        snackWarning ({ commit }, msg) {
            commit('setSnack', { type: 'warning', msg, show: true })
        },
        snackInfo ({ commit }, msg) {
            commit('setSnack', { type: 'info', msg, show: true })
        },
        snackError ({ commit }, msg) {
            commit('setSnack', { type: 'error', msg, show: true })
        },
        clearSnack ({ commit }) {
            commit('setSnack', { type: 'default', msg: '', show: false })
        },
        usernameAction ({ commit }, msg) {
            commit('setUsername', msg )
        },
    },
    getters: {
        snack: state => state.snack,
        loading: ({ loading }) => loading,
        username: state=>state.username
    }
})
